export default defineNuxtRouteMiddleware((to, from) => {
    const uxStore = useUxStore();
    uxStore.isOpenMenu = {}; 
    uxStore.isOpenMobileMenu =  false;
})
